import SignupAccountants from "@/views/gekko/SignupAccountants";
import SignupHeroes from "@/views/gekko/SignupHeroes";
import SignupNew from "@/views/gekko/SignupNew";
import Login from "@/views/gekko/Login";
import Logout from "@/views/gekko/Logout";
import Dashboard from "@/views/gekko/Dashboard";
import Costs from "@/views/gekko/Costs";
import Hours from "@/views/gekko/Hours";
import Bank from "@/views/gekko/Bank";
import BankConnection from "@/views/gekko/BankConnection";
import Invoices from "@/views/gekko/Invoices";
import Quotations from "@/views/gekko/Quotations";
import Contacts from "@/views/gekko/Contacts"
import InvoiceReport from "@/components/invoices/InvoiceReport";
import Trips from "@/views/gekko/Trips";
import AddEditContact from "@/components/contacts/AddEditContact";
import AddEditProject from "@/components/contacts/AddEditProject";
import AddEditTrip from "@/components/trips/AddEditTrip";
import BalanceSheet from "@/views/gekko/BalanceSheet";
import CostTypesSettings from "@/views/settings/CostTypesSettings";
import AddEditInvestmentItem from "@/components/balance_sheet/AddEditItem";
import FinancialReporting from "@/views/gekko/FinancialReporting";
import Documents from "@/views/gekko/Documents";
import AddEditDocument from "@/components/documents/AddEditDocument";
import ShareDocument from "@/components/documents/ShareDocument";
import Reports from "@/views/gekko/Reports";
import HoursReport from "@/views/gekko/HoursReport";
import TaxreportList from "@/views/gekko/TaxreportList";
import Taxreport from "@/views/gekko/Taxreport";
import ForeignVATList from "@/views/gekko/ForeignVATList";
import ForeignVAT from "@/views/gekko/ForeignVAT";
import Products from "@/views/gekko/Products";
import ProductList from "@/views/settings/ProductList";
import CustomerInsight from "@/views/gekko/CustomerInsight";
import SupplierInsight from "@/views/gekko/SupplierInsight";
import CashFlow from "@/views/gekko/CashFlow";
import CostCategories from "@/views/gekko/CostCategories.vue";
import VATReportBE from "@/views/gekko/VATReportBE";
import VATReportBEHome from "@/views/gekko/VATReportBEHome";
import MolliePaymentComplete from "@/views/gekko/MolliePaymentComplete";
import MolliePaymentStart from "@/views/gekko/MolliePaymentStart";
import DeleteAccount from "@/views/gekko/DeleteAccount";
import RevenueExpenses from "@/views/gekko/RevenueExpenses";
import EUServicesReport from "@/views/gekko/EUServicesReport";
import EUServicesHome from "@/views/gekko/EUServicesHome";
import invoicesRoutes from "./invoices/"
import quotationsRoutes from "./quotations"
import QuotationsPublicView from '@/components/quotations/QuotationsPublicView'
import RootlinePaymentStart from '@/views/gekko/RootlinePaymentStart'
import RootlinePaymentComplete from '@/views/gekko/RootlinePaymentComplete'
import BanksRedirect from "@/views/gekko/BanksRedirect.vue";
import UnsubscribeEmail from "@/views/gekko/UnsubscribeEmail.vue";
import DownloadFile from "@/views/gekko/DownloadFile.vue"
import VerifyEmail from '@/views/gekko/VerifyEmail.vue'
import DraftQrCode from "@/views/gekko/DraftQrCode.vue"

// import VueCookies from 'vue-cookies';

/**
 * By default all routes require authentification and are navigation guarded on outer/index.js
 * To make a route public add meta.noAuth = true (see Login)
 */

const routes = [
    { path: '/:language/accountants/signup/', name: 'SignupAccountants', component: SignupAccountants, meta: { title: 'Sign up', noAuth: true } },
    { path: '/:language/heroesinvite/:uuid', name: 'SignupHeroes', component: SignupHeroes, meta: { title: 'Sign up', noAuth: true } },
    {
      path: '/:language/accounts/signup/',
      name: 'Signup',
      component: SignupNew,
      meta: { title: 'Sign up', noAuth: true }
    },
    {
      path: '/:language/accounts/signup-invite/',
      name: 'SignupInvite',
      component: SignupNew,
      meta: { title: 'Sign up Invite', noAuth: true }
    },

    { path: '/:language/accounts/login/', name: 'Login', component: Login, meta: { title: 'Login', noAuth: true } },
    { path: '/:language/accounts/logout/', name: 'Logout', component: Logout, meta: { title: 'Logout' } },

    { path: '/:language/accounts/reset-password/', name: 'ResetPassword', component: Login, meta: { title: 'Reset password', noAuth: true } },
    { path: '/:language/accounts/forgot-password/', name: 'ForgotPassword', component: Login, meta: { title: 'Forgot password', noAuth: true } },
    { path: '/:language/accounts/verify-email/:token', name: 'VerifyEmail', component: VerifyEmail, meta: { title: 'Verify your email', noAuth: true } },
    { path: '/:language/accounts/unsubscribe-email/:token', name: 'UnsubscribeEmail', component: UnsubscribeEmail, pathToRegexpOptions: { strict: true }, meta: { title: 'Unsubscribe Email', public: true, noAuth: true } },
    { path: '/:language/dashboard', name: 'Dashboard', component: Dashboard, meta: { title: 'Dashboard' }, children: [
      { path: 'delete/:uuid', component: Dashboard, name: 'DashboardDeleteAccount', meta: { title: 'Dashboard delete account' }  },
    ]},
    { path: '/:language/costs/',  name: 'Costs', component: Costs, meta: { title: 'Costs' }, pathToRegexpOptions: { strict: true }, children: [
        {  path: 'edit/:costId', name: 'EditCost', meta: { title: 'Edit costs', masterModal: 'edit' } },
        {  path: 'add/', name: 'AddCost', meta: { title: 'Add cost', masterModal: 'add' } },
      ]
    },
    { path: '/:language/hours/', name: 'Hours', component: Hours, meta: { title: 'Hours' }, pathToRegexpOptions: { strict: true } },

    { path: '/:language/bank/', name: 'Bank', component: Bank, meta: { title: 'Bank' }, pathToRegexpOptions: { strict: true } },
    { path: '/:language/bank/transaction/:transaction_id/', name: 'BankTransaction', component: Bank, meta: { title: 'Bank' }, pathToRegexpOptions: { strict: true } },
    { path: '/:language/bank/setup-credentials/', name: "BanksRedirect", component: BanksRedirect, meta: { title: "Setting up credentials" }, pathToRegexpOptions: { strict: true } },
    { path: '/:language/bank/rootline-payment-start/:uuid/', name: 'RootlinePaymentStart', component: RootlinePaymentStart, pathToRegexpOptions: { strict: true }, meta: { title: 'RootlinePaymentStart', public: true, noAuth: true }, },
    { path: '/:language/bank/rootline-payment-complete/:uuid/', name: 'RootlinePaymentComplete', component: RootlinePaymentComplete, pathToRegexpOptions: { strict: true }, meta: { title: 'RootlinePaymentComplete', public: true, noAuth: true }, },
    { path: '/:language/bank/start-payment/:uuid/', name: 'MolliePaymentStart', component: MolliePaymentStart, pathToRegexpOptions: { strict: true }, meta: { title: 'MolliePaymentStart', public: true, noAuth: true }, },
    { path: '/:language/bank/payment-complete/:uuid/', name: 'MolliePaymentComplete', component: MolliePaymentComplete, pathToRegexpOptions: { strict: true }, meta: { title: 'MolliePaymentComplete', public: true, noAuth: true }, },
    { path: '/:language/add-bank-connection/', name: 'BankConnection', component: BankConnection, meta: { title: 'Add Bank Connection' }, pathToRegexpOptions: { strict: true } },
    
    { path: '/:language/invoices/', name: 'Invoices', meta: { title: 'Invoices' }, component: Invoices, pathToRegexpOptions: { strict: true }, children: [
        ...invoicesRoutes
      ] 
    },
    { path: '/:language/invoices/draft-qr-code/', name: 'DraftQrCode', component: DraftQrCode, pathToRegexpOptions: { strict: true }, meta: { title: 'Draft QR Code', public: true, noAuth: true }, },
    
    { path: '/:language/download/:filetype/:uuid/', name: 'DownloadFile', component: DownloadFile, pathToRegexpOptions: { strict: true }, meta: { title: 'Download File', public: true, noAuth: true }, },
   
    { path: '/:language/accounts/delete-account/:uuid/', name: 'DeleteAccount', component: DeleteAccount, pathToRegexpOptions: { strict: true }, meta: { title: 'Delete Account', public: true, noAuth: true }, },
    
    { path: '/:language/quotations/view-online/:uuid/', name: 'QuotationsPublicView', component: QuotationsPublicView, pathToRegexpOptions: { strict: true }, meta: {  title: 'View Quotation', public: true, noAuth: true } },
    { path: '/:language/quotations/', name: 'Quotations', meta: { title: 'Quotations' }, component: Quotations, pathToRegexpOptions: { strict: true }, children: [
        ...quotationsRoutes
      ]
    },
    { path: '/:language/invoices/invoice-report/:customeruuid/:pageid/all/', name: 'InvoiceReport', component: InvoiceReport, meta: { title: 'Invoice Report' } },   
    { path: '/:language/addressbook/', name: 'Contacts', component: Contacts, meta: { title: 'Contacts' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'contact/edit/:contactId', component: AddEditContact, name: 'EditContact', meta: { title: 'Edit contact' } },
      { path: 'contact/add/', component: AddEditContact, name: 'AddContact', meta: { title: 'Add contact' } },
      { path: 'project/edit/:contactId/:projectId', component: AddEditProject, name: 'EditProject', meta: { title: 'Edit project' } },
      { path: 'project/add/:contactId', component: AddEditProject, name: 'AddProject', meta: { title: 'Add project' } }
    ] },
    { path: '/:language/trips/', name: 'Trips', component: Trips, meta: { title: 'Trips' }, pathToRegexpOptions: {strict: true}, children: [
      { path: 'edit/:tripId', component: AddEditTrip, name: 'EditTrip', meta: { title: 'Edit trip' }},
      { path: 'add/', component: AddEditTrip, name: 'AddTrip', meta: { title: 'Add trip' }}
    ] },
    { path: '/:language/investments/', name: 'BalanceSheet', component: BalanceSheet, meta: { title: 'Balance Sheet Investments' }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'costtypes/', component: CostTypesSettings, name: 'CostTypes', meta: { title: 'Cost types' } },
      { path: 'editcost/:costId', name: 'BalanceSheetEditCost', meta: { title: 'Edit costs', masterModal: 'edit' } },
      { path: 'additem/', component: AddEditInvestmentItem, name: 'AddInvestmentItem', meta: { title: 'Add item' } },
      { path: 'edititem/:investmentId', component: AddEditInvestmentItem, name: 'EditInvestmentItem', meta: { title: 'Edit item' } }
    ] },
    { path: '/:language/financial-statements/', name: 'FinancialStatements', component: FinancialReporting, meta: { title: 'Financial Statements' }, pathToRegexpOptions: { strict: true }, children: [] },
    { path: '/:language/documents/', name: 'Documents', component: Documents, meta: {title: 'Documents'}, pathToRegexpOptions: {strict: true}, children: [
      {path: 'edit/:documentId', component: AddEditDocument, name: 'EditDocument', meta: { title: 'Edit documents' }},
      {path: 'add/', component: AddEditDocument, name: 'AddDocument', meta: { title: 'Add document'}},
      {path: 'share/', component: ShareDocument, name: 'ShareDocuments', meta: { title: 'Share Documents'},
        children: [
          {path: ':documentId', component: ShareDocument, name: 'ShareDocument', meta: { title: 'Share document' }}
        ]
      }
    ]},
    { path: '/:language/reports/', name: 'Reports', component: Reports, meta: { title: 'Reports' }, pathToRegexpOptions: {strict: true}, children: [] },
    { path: '/:language/reports/hours/', component: HoursReport, name: 'HoursReport', meta: { title: 'Hours Report' }, pathToRegexpOptions: {strict: true}, children: []  },
    
    { path: "/:language/reports/vat/", component: TaxreportList, name: "TaxreportList", meta: { title: 'Reports' }, pathToRegexpOptions: {strict: true}, children: [
        { path: "create/", component: Taxreport, name: "CreateTaxreport", meta: { title: 'Create report' } },
        { path: ":id/", component: Taxreport, name: "ViewTaxreport", meta: { title: 'View report' } },
    ]},

    { path: "/:language/reports/foreign-vat/", component: ForeignVATList, name: "ForeignVATList", meta: { title: 'Foreign VAT Report' } },
    { path: "/:language/reports/foreign-vat/:id", component: ForeignVAT, name: "ForeignVAT", meta: { title: 'Foreign VAT Report' } },
    { path: "/:language/reports/foreign-vat-report/", component: ForeignVAT, name: "ForeignVATSample", meta: { title: 'Foreign VAT Report' } },

    { path: "/:language/reports/products/", component: Products, name: "Products", meta: { title: "Products" }, pathToRegexpOptions: { strict: true }, children: [
      {path: "list/", component: ProductList, name: "ProductListModal", meta: {title: "Product List"}}
    ] },
    { path: "/:language/reports/customer-insight/", component: CustomerInsight, name: "CustomerInsight", meta: { title: "Customer Insight" }, pathToRegexpOptions: { strict: true }, children: [] },
    { path: "/:language/reports/supplier-insight/", component: SupplierInsight, name: "SupplierInsight", meta: { title: "Supplier Insight" }, pathToRegexpOptions: { strict: true }, children: [] },
    { path: "/:language/reports/cash-flow/", component: CashFlow, name: "CashFlow", meta: { title: "Cash Flow" }, pathToRegexpOptions: { strict: true }, children: [] },
    { path: "/:language/reports/cost-categories/", component: CostCategories, name: "CostCategories", meta: { title: "Cost Categories" }, pathToRegexpOptions: { strict: true }, children: [
      { path: 'costtypes/', component: CostTypesSettings, name: 'CostTypesReport', meta: { title: 'Cost types' } }
    ]},
    { path: "/:language/reports/be-vat/", component: VATReportBEHome, name: "VATReportBEList", meta: { title: 'Belgian VAT Report List' }, pathToRegexpOptions: { strict: true }, children: [
        { path: "create/", component: VATReportBE, name: "VATReportBECreate", meta: { title: 'Belgian VAT Report' } },
        { path: ":id/", component: VATReportBE, name: "VATReportBE", meta: { title: 'Belgian VAT Report' } },
    ] },
    { path: "/:language/reports/revenue-expenses/", component: RevenueExpenses, name: "RevenueExpenses", meta: { title: "Revenue and Expenses" }, pathToRegexpOptions: { strict: true }, children: []},
    { path: "/:language/reports/eu-services/", component: EUServicesHome, name: "EUServicesList", meta: {title: 'EU Services Report List' }, pathToRegexpOptions: { strict: true }, children: [
        { path: "create/", component: EUServicesReport, name: "EUServicesReportCreate", meta: { title: 'EU Services Report' } },
        { path: ":id/", component: EUServicesReport, name: "EUServicesReport", meta: { title: 'EU Services Report' } },
    ]}
  ];

export default routes;
